<div class="sr-only">
  <p>
    {{ caption }}
    {{ summary }}
  </p>
</div>

<table *ngIf="isVisible" [style]="{ minWidth: minWidth }" [ngClass]="{ 'left-column-heading': leftColumnHeading }">
  <!-- A11y settings -->
  <ng-container *ngFor="let column of data.columns">
    <ng-container *ngIf="!column.children">
      <col />
    </ng-container>
    <ng-container *ngIf="column.children">
      <colgroup [span]="column.children.length"></colgroup>
    </ng-container>
  </ng-container>

  <thead>
    <tr class="table-header">
      <ng-container *ngFor="let column of data.columns; trackBy: trackByColumnId">
        <ng-container *ngIf="column.title">
          <th
            [attr.colspan]="column.childrenActive ? column.children?.length : 1"
            [width]="100 / data.columns.length + '%'"
            [scope]="column.children ? 'colgroup' : 'col'"
            (click)="column.children ? onToggleChildren(column) : null"
            (keyup.enter)="column.children ? onToggleChildren(column) : null"
            [ngClass]="{ children: column.children, active: column.childrenActive }"
            [tabIndex]="column.children ? 0 : -1"
            [id]="column.id"
          >
            <div class="cell-inner">
              <button *ngIf="column.children" aria-hidden="true" tabindex="-1">
                <app-icon [icon]="globalIcons.ChevronDown"></app-icon>
              </button>
              <div class="column-title">
                {{ column.title }}
                <span *ngIf="column.subtitle" class="subtitle"> {{ column.subtitle }} </span>
              </div>
            </div>
          </th>
        </ng-container>
        <!-- Empty heading cell -->
        <ng-container *ngIf="!column.title">
          <td [scope]="column.children ? 'colgroup' : ''" [width]="100 / data.columns.length + '%'"></td>
        </ng-container>
      </ng-container>
    </tr>
    <!-- Table Header Children -->
    <tr *ngIf="doChildColumnsExist()" class="table-header">
      <ng-container *ngFor="let column of data.columns; let index = index; trackBy: trackByColumnId">
        <!-- Empty child Header -->
        <ng-container *ngIf="!column.children && !column.disabled">
          <td [width]="100 / data.columns.length + '%'"></td>
        </ng-container>

        <!-- Inactive child header -->
        <ng-container *ngIf="column.children && !column.childrenActive && !column.disabled">
          <th scope="col">Total</th>
        </ng-container>

        <!-- Active Children headers -->
        <ng-container *ngIf="column.children && column.childrenActive && !column.disabled">
          <th *ngFor="let childColumn of column.children" scope="col">
            {{ childColumn.title }}
          </th>
        </ng-container>
      </ng-container>
    </tr>
  </thead>

  <!-- Body -->
  <ng-container *ngFor="let row of data.rows; trackBy: trackByRowId">
    <!-- Parent or single row -->
    <app-body-row [row]="row" [data]="data" [ignoreReadOnly]="ignoreReadOnly" [disabled]="disabled"></app-body-row>

    <!-- Child rows -->
    <app-recursive-row *ngIf="row.children" [row]="row" [data]="data"></app-recursive-row>
  </ng-container>
</table>

<div class="table-buttons">
  <app-button *ngIf="showClearTableButton" (buttonClicked)="clearTable()">{{
    GLOBAL_STRINGS.CLEAR_VALUES | translateString
  }}</app-button>
</div>
